import {Injectable} from '@angular/core';
import {ContractControlService} from '../../contract-control.service';


@Injectable({
    providedIn: 'root'
})

export class contractControlConstant {
    constructor (private contractService: ContractControlService) {}

    //TODO: consider to extract it as the helper method
    /**
     * Copying object to avoid sync
     * @param obj 
     * @returns 
     */
    _deepCopy = (obj) => {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
    
        if (obj instanceof Date) {
            return new Date(obj.getTime());
        }
    
        if (Array.isArray(obj)) {
            return obj.map(this._deepCopy);
        }
    
        const copiedObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                copiedObj[key] = this._deepCopy(obj[key]);
            }
        }
        return copiedObj;
    }
    
}
